import EyeIcon from "@/assets/colorable/eye.svg?react";
import Button from "@/components/Common/Button";
import clsxm from "@/lib/clsxm";
import {type FC, type ReactNode} from "react";
import {useTranslation} from "react-i18next";
import {useMedia} from "react-use";

const PreviewButton: FC<{
  className?: string;
  collapseOnSmallerScreen?: boolean;
  icon?: ReactNode;
  link: string;
}> = ({className, collapseOnSmallerScreen, icon, link}) => {
  const {t} = useTranslation("common");
  const isUnderMd = useMedia("(max-width: 768px)");

  return (
    <Button
      buttonStyle="White"
      onClick={() => window.open(link, "_blank")}
      className={clsxm("h-fit min-h-8 w-fit gap-2.5 px-5 py-0 text-sm", className)}>
      {collapseOnSmallerScreen && isUnderMd ? (
        (icon ?? <EyeIcon className="size-4" />)
      ) : (
        <>
          {icon !== undefined ? icon : <EyeIcon className="size-4" />}
          <span>{t("preview")}</span>
        </>
      )}
    </Button>
  );
};

export default PreviewButton;
